import searchSetup from 'Redux/ducks/algolia-setup';
import { topSellerIndex } from 'Redux/ducks/algolia-calls';

// Fixed pages to send client to on specific search results
const fixedResults = [
  {
    key: 'bundle',
    path: 'bundle',
    cover: 'a8a87de9-eb36-4cf5-9e1c-45df439adff8.jpeg',
    name: 'Fanatical Bundles',
  },
  {
    key: 'vr',
    path: 'vr-games',
    cover: '3716de7f-5581-47d2-a2fe-f2c6d5a362f6.jpeg',
    name: 'VR',
  },
  {
    key: 'virtual reality',
    path: 'vr-games',
    cover: '3716de7f-5581-47d2-a2fe-f2c6d5a362f6.jpeg',
    name: 'Virtual Reality',
  },
  {
    key: 'ebook',
    path: 'bundle/books',
    cover: '7e807a28-afbf-4358-b0fd-952a1f54ce3c.jpeg',
    name: 'eBooks',
  },
  {
    key: 'book',
    path: 'bundle/books',
    cover: '7e807a28-afbf-4358-b0fd-952a1f54ce3c.jpeg',
    name: 'eBooks',
  },
  {
    key: 'mac',
    path: 'mac-games',
    cover: '43285ba8-4d79-44ad-b736-7d13e660b7ca.jpeg',
    name: 'Mac',
  },
  {
    key: 'linux',
    path: 'linux-games',
    cover: '0369848d-ab9e-4a46-b475-de39ee382ebd.jpeg',
    name: 'Linux',
  },
  {
    key: 'steam deck',
    path: 'steam-deck-games',
    cover: '98e3d99b-50b0-46a1-8dd1-40ac31a04e71.jpeg',
    name: 'Steam Deck',
  },
];

let combinedFixedResults = fixedResults;

const formatFacet = facet => ({
  key: facet.name.toLowerCase().replace(/-/g, ' ').replace(/[^a-zA-Z0-9 ]/g, ''),
  path: `${facet.facet.replace('combo', 'combo-collections')}/${facet.slug}`,
  name: facet.name,
  facetName: facet.name,
  cover: facet.cover_image || `facet/${facet.facet}/${facet.slug}`,
  count: facet.count,
});

// Match the start of the word from the list above to the search string
const partialMatchFixed = (string) => {
  const regex = new RegExp(`^${string.replace(/-/g, ' ').replace(/[^a-zA-Z0-9 ]/g, '').replace(/s$/, '')}s?`, 'i');
  return combinedFixedResults.filter(result => regex.test(result.key));
};

const searchCache = {};

export default async function fetchAutoSearch(searchString, hitsPerPage = 5, filters = '', allFacets = []) {
  const query = (searchString ? searchString.replace(/[^\w\s]/gi, ' ') : '').trim();

  const cacheKey = `${filters}|${hitsPerPage}|${allFacets.length}|${query}`;

  if (searchCache[cacheKey]) {
    return searchCache[cacheKey];
  }

  if (combinedFixedResults.length !== (allFacets.length + fixedResults.length)) {
    combinedFixedResults = [...fixedResults, ...allFacets.map(formatFacet)];
  }

  const index = await searchSetup(topSellerIndex());
  return index.search(query, {
    hitsPerPage,
    filters,
    analyticsTags: ['userSearch', 'autoSearch'],
  }).then((autoSearchResults) => {
    const results = Object.assign({}, autoSearchResults);
    const fixedMatches = partialMatchFixed(searchString);

    if (fixedMatches.length) {
      results.hits = [
        ...autoSearchResults.hits,
        ...fixedMatches.map(res => Object.assign({ fixed: true }, res)).slice(0, 3),
      ];

      results.nbHits = fixedMatches.length + autoSearchResults.nbHits;
    }

    searchCache[cacheKey] = results;

    return results;
  });
}
